const rootArea = "/fees";

export const feesGlob = (baseArea = "") => ({
	self: `${baseArea}${rootArea}`,
	byType: (typeCode: string) => ({ 						
		read: `${baseArea}${rootArea}/${typeCode}/read`,
		create: `${baseArea}${rootArea}/${typeCode}/create`,
		update: `${baseArea}${rootArea}/${typeCode}/update`
	})
});